var map = {
	"./prepareQuizImage1.png": 1649,
	"./prepareQuizImage2.png": 5381,
	"./prepareQuizImage3.png": 2005,
	"./prepareQuizImage4.png": 8697,
	"./prepareQuizImage5.png": 5463,
	"./prepareQuizImage6.png": 9734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8913;